import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const NoMatch = () => {
  return (
    <div className="p-3">
      <h2>このページは存在しません。</h2>
    </div>
  );
}
  
export default NoMatch;
